
























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { UserStateModule } from '@/store';
import { CONSTANTS } from '@/core';
import { AccountModel, FileUploadModel } from '../../type';
import { MembersService } from '@/kuroco_api/services/MembersService';
import { Uploader, UploaderFactory } from '@/kuroco_api/core/Uploader';

@Component<ProfileEdit>({})
export default class ProfileEdit extends Vue {
  // PROPS
  @Prop({
    type: Boolean,
    required: true,
    default: false,
  })
  shows!: boolean;

  // FIELDS
  uploader!: Uploader;
  UserStateModule = UserStateModule;
  userName = '';
  postingState = 'PRE';
  file?: File;
  memberPhoto: Partial<MemberPhoto> = {};

  // MUTATIONS
  get isLoading() {
    return this.postingState === 'LOADING';
  }
  get imgButtonStyle() {
    return this.postingState === 'COMPLETE'
      ? {
          opacity: 0.3,
          cursor: 'pointer',
        }
      : { opacity: 0, cursor: 'unset' };
  }
  get avatarImage(): string {
    return !!this.memberPhoto.file_id ? window.URL.createObjectURL(this.file) : this.myAvatarSrc;
  }
  get myAvatarSrc(): string {
    return this.UserStateModule.myImage;
  }

  // METHODS
  async handleChangeFileInput(e: Event) {
    const newFile = (e.target as any).files[0];
    if (newFile === undefined) {
      return;
    }

    // checking whether this file have a proper extension.
    const properExts = [CONSTANTS.UPLOADABLE_FILETYPE_DEF.PNG, CONSTANTS.UPLOADABLE_FILETYPE_DEF.JPEG]
      .map((def) => def.exts)
      .flat(1);
    if (!properExts.includes(newFile.name.split(/\./g).pop())) {
      window.alert(`${newFile.name} の拡張子は対応していません。`);
      return;
    }

    this.postingState = 'LOADING';

    const { file_id } = await this.uploader.upload(newFile).catch((e) => {
      this.postingState = 'ERROR';
      (this as any).$snack.danger({ text: 'エラーが発生しました。', button: 'OK' });
      return Promise.reject();
    });

    this.file = newFile;
    this.memberPhoto = {
      file_id,
      file_nm: newFile.name,
    };
    this.postingState = 'PRE';
    (this as any).$snack.success({ text: '画像を変更しました。', button: 'OK' });
  }
  handleClickSubmit(e: Event) {
    if (!this.userName || this.userName === '') {
      window.alert(`ユーザー名は空にできません。`);
      return;
    }

    const query: MembersService.postMembersServiceRcmsApi1MemberUpdateRequest = {
      requestBody: {
        nickname: this.userName,
        member_photo: this.memberPhoto,
      },
    };

    this.postingState = 'LOADING';
    UserStateModule.updateUser(query)
      .then(() => {
        this.postingState = 'COMPLETE';
        (this as any).$snack.show({ text: 'ユーザー情報を更新しました。' });
      })
      .catch((e) => {
        this.postingState = 'ERROR';
        (this as any).$snack.danger({ text: 'エラーが発生しました。' });
      });
  }
  async uploadImageToStorage(file: File) {
    return await this.uploader.upload(file);
  }

  // LIFECYCLE HOOKS
  async mounted() {
    this.uploader = await UploaderFactory.create({});
    this.userName = this.UserStateModule.selfUser.nickname;
  }
}

interface MemberPhoto {
  file_id: string;
  file_nm: string;
}
